import {TreeNode} from 'primeng/api';

export interface SiTreeNode extends TreeNode {
  level?: number;
}

export class TreeTableNodeEvent {
  node: SiTreeNode;
  originalEvent: Event;
}
